import React, { createContext, useContext } from "react";
import useContent from '../Hooks/useContent';

const SharedDataContext = createContext();

export function SharedDataProvider({ children }) {
    const endpoint = window.apiEndpoint;

    if (!endpoint) {
        console.error("API endpoint is not defined. Please set window.apiEndpoint in env.conf.js");
    }

    const { content, loading, error } = useContent(endpoint);

    return (
        <SharedDataContext.Provider value={{ content, loading, error }}>
            {children}
        </SharedDataContext.Provider>
    );
}

export function useSharedData() {
    return useContext(SharedDataContext);
}